import styled, { css } from 'styled-components';
import { StyleVars } from 'core/utils/Styles';

export const SpinWrapper = styled.div`
	margin: 32px 0;
`;

export const Title = styled.h4`
	margin: 32px 0;
	font-size: 24px;
	font-weight: 600;

	${props => !props.$leftAlign && css`
		@media (max-width: ${StyleVars.cancelBreakpointMd}) {
			text-align: center;
		}
	`}
`;

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	grid-gap: 16px;
	-webkit-overflow-scrolling: touch;
	@media (max-width: ${StyleVars.cancelBreakpointMd}) {
		max-width: calc(100vw - 32px);
		margin: 0 auto;
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	}
`;

export const Container = styled.div`
	${props => !props.noPadding && css`
		padding-top: ${StyleVars.defaultSpacingUnit * 3}px;
	`}
`;

const cardMinWidth = size => css`
	width: ${size};
	flex-basis: ${size};
	max-width: ${size};
	min-width: ${size};
`;

export const ScrollWrapper = styled.section`
	margin: 16px 0;

	.listing-card-column {
		${cardMinWidth("267px")}
		@media(max-width: ${StyleVars.screenMd}) {
			${cardMinWidth("180px")}
		}
	}
`;
